import { render, staticRenderFns } from "./Medyola.vue?vue&type=template&id=ea8fed36&scoped=true"
import script from "./Medyola.vue?vue&type=script&lang=js"
export * from "./Medyola.vue?vue&type=script&lang=js"
import style0 from "./Medyola.vue?vue&type=style&index=0&id=ea8fed36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8fed36",
  null
  
)

export default component.exports